<template>
    <rkm-form
        v-if="model"
        ref="Form"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :search-fields="fields"
                    label="Usuário"
                    text-field="cidadaoNome"
                    v-model="model.usuario"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-area
            v-if="form.papeis.length > 0"
            no-margin-top
            title="Papéis"
        >
            <rkm-form-checkbox-group v-model="model.papeis">
                <rkm-form-checkbox
                    v-for="papel in form.papeis"
                    :key="papel.id"
                    :value="papel.id"
                >
                    {{papel.nome}}
                </rkm-form-checkbox>
            </rkm-form-checkbox-group>
        </rkm-area>

        <rkm-row v-if="form.modulos.length > 0">
            <rkm-col>
                <rkm-tabs>
                    <rkm-tab
                        v-for="modulo in form.modulos"
                        :key="modulo.id"
                        :title="modulo.nome"
                    >
                        <rkm-row>
                            <rkm-col cols="12">
                                <rkm-button
                                    @click="checkAll(modulo.id)"
                                    color="primary"
                                    small
                                >
                                    Marcar todos
                                </rkm-button>

                                <rkm-button
                                    @click="uncheckAll(modulo.id)"
                                    outline
                                    small
                                >
                                    Desmarcar todos
                                </rkm-button>
                            </rkm-col>
                        </rkm-row>

                        <rkm-row cols="3">
                            <rkm-col
                                v-for="funcionalidade in modulo.funcionalidades"
                                :key="funcionalidade.id"
                            >
                                <rkm-area
                                    :title="funcionalidade.nome"
                                    no-margin-top
                                >
                                    <rkm-form-checkbox-group v-model="model.permissoes">
                                        <rkm-form-checkbox
                                            v-for="permissao in funcionalidade.permissoes"
                                            :key="permissao.id"
                                            :value="permissao.id"
                                        >
                                            {{permissao.nome}}
                                        </rkm-form-checkbox>
                                    </rkm-form-checkbox-group>
                                </rkm-area>
                            </rkm-col>
                        </rkm-row>
                    </rkm-tab>
                </rkm-tabs>
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
            }
        },
    },
    created() {
        this.repositories = {
            gestor: this.getConectaSusRepository('administracao.gestor'),
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario')
        }
    },
    data: () => ({
        fields: [
            {key: 'cadastro_cidadao.nome', searchable: true},
        ],
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        checkAll(moduloId) {
            const modulo = this.form.modulos.find(modulo => modulo.id === moduloId)

            if (modulo) {
                modulo.funcionalidades.map(funcionalidade => funcionalidade.permissoes.map(permissao => {
                    if (!this.model.permissoes.includes(permissao.id)) {
                        this.model.permissoes.push(permissao.id)
                    }
                }))
            }
        },
        uncheckAll(moduloId) {
            const modulo = this.form.modulos.find(modulo => modulo.id === moduloId)

            if (modulo) {
                modulo.funcionalidades.map(funcionalidade => funcionalidade.permissoes.map(permissao => {
                    const index = this.model.permissoes.findIndex(id => id === permissao.id)

                    if (index >= 0) {
                        this.model.permissoes.splice(index, 1)
                    }
                }))
            }
        },
        load() {
            this.setLoading()

            const request = this.id
                ? this.repositories.gestor.edit(this.id)
                : this.repositories.gestor.create()

            request
                .then(({data}) => {
                    this.form = data.form
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    const request = {
                        usuarioId: this.model.usuario ? this.model.usuario.id : null,
                        permissoes: this.model.permissoes,
                        papeis: this.model.papeis,
                    }

                    this.repositories.gestor.store(this.camelObjectKeysToSnakeRecursive(request))
                        .then(({ data }) => {
                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        update() {
            this.$refs.Form.validate()
                .then(valid => {
                    if (!valid) return

                    this.setLoading()

                    const request = {
                        usuarioId: this.model.usuario ? this.model.usuario.id : null,
                        permissoes: this.model.permissoes,
                        papeis: this.model.papeis,
                    }

                    this.repositories.gestor.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                        .then(({ data }) => {
                            this.showSaveNotification()
                            this.$emit('save', data)
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        save() {
            if (this.id) {
                this.update()
            } else {
                this.store()
            }
        },
    },
    mixins: [error, object, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>